import React from 'react';
import { LoadingButton } from '@mui/lab';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

const TextButton = ({ children, typographyProps, ...props }) => (
  <LoadingButton {...props}>
    <Typography {...typographyProps}>
      {children}
    </Typography>
  </LoadingButton>
);

TextButton.propTypes = {
  children: PropTypes.node.isRequired,
  typographyProps: PropTypes.shape(),
};
TextButton.defaultProps = {
  typographyProps: {},
};

export default TextButton;
